import React, {useEffect, useState} from "react";
import {AppComponent} from "../App";
import css from "../css/admin.module.css";
import {Button, Paper} from "@mui/material";
import {post} from "./post";

export const Logs = () => {
    const [json, setJSON] = useState(null);
    const [logs, setLogs] = useState([]);
    const [currentLogId, setCurrentLogId] = useState(null);

    useEffect(() => {
        AppComponent.SetLoading(true);
        post("getLogs").then(setLogs)
        AppComponent.SetLoading(false);
    }, [])

    const getLog = async (logId) => {
        setCurrentLogId(logId);
        setJSON(null);
        AppComponent.SetLoading(true);
        setJSON(await post("getLog", {logId}))
        AppComponent.SetLoading(false);
    }

    const deleteLog = async (logId) => {
        if(!window.confirm("Delete?"))return;
        setJSON(null);
        const index = logs.indexOf(logId);

        const newLogs = logs.filter(log => log !== logId);
        const newLogId = newLogs[index + 1 < newLogs.length ? index + 1 : newLogs.length - 1];
        setCurrentLogId(newLogId);
        getLog(newLogId);

        setLogs(newLogs);
        post("deleteLog", {logId});
    }

    if(json && json.url){
        json.vk_user_id = new URLSearchParams(json.url).get("vk_user_id");
        json.vk_user_id = json.vk_user_id === "554220229" ? "Наири" : json.vk_user_id;
    }

    return (
        <div className={css.settings}>
            <Paper elevation={3} className={css.admin}>
                <div className={css.body}>
                    <div style={{overflow: "auto", marginBottom: 32}} className={css.buttons}>
                        {logs.map(logId => (
                            <div style={{padding: 4, background: logId===currentLogId && "#f6b929"}} key={logId}>
                                <Button variant={"contained"} onClick={() => getLog(logId)}>
                                    {logId.split("/")[1].split(".json")[0].split("-").slice(0,6).join("-")}
                                </Button>
                                <Button color={"error"} onClick={() => deleteLog(logId)}>Delete</Button>
                            </div>
                        ))}
                    </div>
                    <div className={css.json}>
                        <div className={css.preContainer}>
                            <pre>
                                {json && JSON.stringify(json, null, "  ")}
                            </pre>
                        </div>
                    </div>
                </div>
            </Paper>
        </div>
    )
}
